import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { Scrollbars } from '@meitu/saas-ui';
import { CustomTitle } from '@meitu/saas-ui/es/title';
import DragPopover from '@/editor/collapse/views/brush-collapse/custom-btn/drag-popover';
import './text-animation-list.less';
import { MaterialIdsType } from '@meitu/saas-editor-core/es/version-types';
import { editor } from '@/instance';
import './index.less';
import IconFont from '@meitu/xdesign-icon-font';

type Props = {
    layerId: string;
    onClose: () => void;
    onClick: (material: TextAnimationMaterial | null) => void;
    textAnimationMaterialList: TextAnimationMaterial[];
};

export type TextAnimationMaterial = {
    id: string;
    name: string;
    thumbnail: {
        url: string;
        width: number;
        height: number;
    };
    threshold: string;
    type_id: number;
};

const TextAnimationList: React.FC<Props> = ({ onClose, layerId, onClick, textAnimationMaterialList }) => {
    const layer = editor.stage.getLayer(layerId);
    const draggleRef = useRef<HTMLDivElement>(null);

    const setAnimateId = (id: string) => {
        if (!layer) return;
        layer.materialIds = layer.materialIds || {};
        layer.materialIds[MaterialIdsType.TEXT_ANIMATION] = [id.toString()];
    };

    const setDefaultStyle = () => {
        if (!layer) return;
        layer.materialIds = layer.materialIds || {};
        layer.materialIds[MaterialIdsType.TEXT_ANIMATION] = [];
        onClick(null);
    };
    return (
        <DragPopover draggleRef={draggleRef}>
            <div className="text-animation-list" ref={draggleRef}>
                <div className="text-animation-list__title">
                    <CustomTitle
                        leftNode={<div className="left">文字动效</div>}
                        rightNode={
                            <div className="right" onClick={onClose}>
                                <IconFont name="CrossBlack" fontSize={12} color="var(--content-system-secondary)" />
                            </div>
                        }
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <Scrollbars>
                        <div className="text-animation-list__list">
                            <div
                                className={classNames('text-animate-item', {
                                    'text-animate-item--cancel': true,
                                })}
                                onClick={setDefaultStyle}
                            >
                                <div className="none">
                                    <IconFont name="SlashCircleBold" fontSize={28} color="rgba(171, 173, 178, 1)" />
                                </div>
                                <span className="name">无</span>
                            </div>
                            {textAnimationMaterialList.map((item) => {
                                return (
                                    <div
                                        className={`text-animate-item ${'animateId' === item.id.toString() ? 'active' : ''}`}
                                        key={item.id}
                                        onClick={() => {
                                            setAnimateId(item.id);
                                            onClick(item);
                                        }}
                                    >
                                        <img src={item.thumbnail.url} alt="textMark" />
                                        <div className="name">{item.name}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </Scrollbars>
                </div>
            </div>
        </DragPopover>
    );
};

export default React.memo(TextAnimationList);
